import React, { FC } from 'react';
import { LiquidityWizardMinInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedMintInfo';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import { AddLiquidityManual } from '../AddLiquidityManual/AddLiquidityManual';
import { AddLiquidityByIchi } from '../AddLiquidityByIchi/AddLiquidityByIchi';
import { AddLiquidityBySteer } from '../AddLiquidityBySteer/AddLiquidityBySteer';
import { AddLiquidityByGamma } from '@app/screens/liquidity/LiquidityWizard/components/SelectModeStep/components/AddLiquidityByGamma';

interface Props {
  mintInfo: LiquidityWizardMinInfo;
}

export const AddLiquidityByProvider: FC<Props> = ({ mintInfo }) => {
  const {
    currencyA,
    currencyB,
    actions: { setProvider },
    provider,
    mode
  } = useLiquidityWizardState();

  if (mode === 'manual' && mintInfo.poolAddress) {
    return <AddLiquidityManual mintInfo={mintInfo} />;
  }

  if (provider === 'ichi' && currencyA && currencyB && mintInfo.poolAddress) {
    return <AddLiquidityByIchi mintInfo={mintInfo} />;
  }

  if (provider === 'steer' && mintInfo.poolAddress) {
    return <AddLiquidityBySteer mintInfo={mintInfo} />;
  }

  if (provider === 'gamma' && mintInfo.poolAddress) {
    return <AddLiquidityByGamma mintInfo={mintInfo} />;
  }

  return null;
};
